import React from 'react';
import { Form, Input, Button, Row, Col, FormInstance } from 'components';
import { emailRegexp } from 'utils/helpers';
import { ValidationErrors } from 'constants/validations';
import { VALIDATION_MESSAGE } from 'constants/validations/messages';

const { Item } = Form;

export interface ForgotPasswordFormData {
  email: string;
}

export interface ForgotPasswordFormProps {
  form: FormInstance;
  onFinish: (values: ForgotPasswordFormData) => void;
  loading?: boolean;
  submitButtonText?: string;
  onBackToLogin?: () => void;
  backToLoginText?: string;
  showBackToLogin?: boolean;
}

export const ForgotPasswordForm: React.FC<ForgotPasswordFormProps> = ({
  form,
  onFinish,
  loading = false,
  submitButtonText = 'Request Reset Link',
  onBackToLogin,
  backToLoginText = 'Back to Sign In',
  showBackToLogin = true,
}) => {
  return (
    <Form form={form} layout="vertical" onFinish={onFinish}>
      <Row gutter={[0, 24]}>
        <Col span={24}>
          <Item
            label="Email *"
            name="email"
            rules={[
              {
                required: true,
                message: ValidationErrors.required('Email'),
              },
              {
                pattern: emailRegexp,
                message: VALIDATION_MESSAGE.EMAIL,
              },
            ]}
          >
            <Input size="large" />
          </Item>
        </Col>
        <Col span={24}>
          <Button
            size="large"
            type="primary"
            htmlType="submit"
            block
            loading={loading}
            style={{
              backgroundColor: '#05796B',
              borderColor: '#05796B',
              height: '48px',
              fontSize: '16px',
              fontWeight: '600',
            }}
          >
            {submitButtonText}
          </Button>
        </Col>
        {showBackToLogin && onBackToLogin && (
          <Col span={24} style={{ textAlign: 'center', marginTop: '16px' }}>
            <span
              onClick={onBackToLogin}
              style={{
                color: '#05796B',
                cursor: 'pointer',
                fontSize: '14px',
              }}
            >
              {backToLoginText}
            </span>
          </Col>
        )}
      </Row>
    </Form>
  );
};
